var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2",
    "data-name": 2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.16 98.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d3d3d;}.cls-2{fill:#ff7300;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "training-page-sliced") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,87.08H41.33V79.17H100a3.18,3.18,0,0,1,3.17,3.18V83.9A3.17,3.17,0,0,1,100,87.08Zm-57.34-1.3H100a1.88,1.88,0,0,0,1.88-1.88V82.35A1.88,1.88,0,0,0,100,80.47H42.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.78,36A12.82,12.82,0,1,1,35.59,23.19,12.83,12.83,0,0,1,22.78,36Zm0-24.34A11.52,11.52,0,1,0,34.3,23.19,11.54,11.54,0,0,0,22.78,11.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.84,87.19H1.56V50.66A13.37,13.37,0,0,1,14.92,37.31h.77A14.13,14.13,0,0,1,29.81,51.43l0,6.19H30l32.07,0A6.23,6.23,0,0,1,62,70.1H30.11l-1.3,0a5.46,5.46,0,0,1-3.93-1.79L14.18,56.61c-.09.1-.19.21-.25.29a4.91,4.91,0,0,1-.41.45.3.3,0,0,0,0,.41l11,11.95a5.85,5.85,0,0,0,4.32,1.9l.46,0,.6,0Zm-27-1.3H28.54v-13a7.18,7.18,0,0,1-5-2.31l-10.95-12a1.57,1.57,0,0,1,.1-2.23,3.63,3.63,0,0,0,.28-.33c.37-.44.75-.89,1.28-.9a.85.85,0,0,1,.68.29L25.83,67.41a4.2,4.2,0,0,0,3,1.38H62a4.93,4.93,0,1,0,0-9.86l-33.48,0,0-7.48A12.84,12.84,0,0,0,15.69,38.6l-.72,0-.32,0,0,0a12.07,12.07,0,0,0-11.76,12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.19,39.51A2.5,2.5,0,0,0,92,41.07L81.42,72H43.5a2.5,2.5,0,0,0,0,5H83.17a2.49,2.49,0,0,0,2-1.08,2.44,2.44,0,0,0,.38-.69L96.74,42.68A2.49,2.49,0,0,0,95.19,39.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg1);
export default __webpack_public_path__ + "static/media/card-img-1.7a2f7d087a54148315c0ff76e9c2e009.svg";
export { ForwardRef as ReactComponent };